// AUTO GENERATED
// DO NOT MODIFY

export const shadow = {
  small: {
    desktopValue: '0px 5px 20px 0px #0000001A',
    desktopDarkValue: '0px 5px 20px 0px #0000001A',
    iosValue: '0px 5px 20px 0px #0000001A',
    iosDarkValue: '0px 5px 20px 0px #0000001A',
    androidValue: '0px 5px 20px 0px #0000001A',
    androidDarkValue: '0px 5px 20px 0px #0000001A',
    comment: 'Тень для мелких элементов интерфейса, например Chips'
  },
  'small-hover': {
    desktopValue: '0px 14px 42px 0px #0000001F',
    desktopDarkValue: '0px 14px 42px 0px #0000001F',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null
  },
  medium: {
    desktopValue: '0px 6px 34px 0px #0000001F',
    desktopDarkValue: '0px 6px 34px 0px #0000001F',
    iosValue: '0px 6px 34px 0px #0000001F',
    iosDarkValue: '0px 6px 34px 0px #0000001F',
    androidValue: '0px 6px 34px 0px #0000001F',
    androidDarkValue: '0px 6px 34px 0px #0000001F',
    comment: 'Тень для карточек и других больших объектов, например тултипов'
  },
  'medium-hover': {
    desktopValue: '0px 18px 60px 0px #0000002E',
    desktopDarkValue: '0px 18px 60px 0px #0000002E',
    iosValue: null,
    iosDarkValue: null,
    androidValue: null,
    androidDarkValue: null
  },
  popup: {
    desktopValue: '0px 20px 50px 0px #00000036',
    desktopDarkValue: '0px 20px 50px 0px #00000036',
    iosValue: '0px 20px 50px 0px #00000036',
    iosDarkValue: '0px 20px 50px 0px #00000036',
    androidValue: '0px 20px 50px 0px #00000036',
    androidDarkValue: '0px 20px 50px 0px #00000036',
    comment: 'Тень для карточек, всплывающих поверх контента: например попап-онбординг'
  }
};